import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityExistCheckerFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'entity-exist-checker-form-field-extension',
    params: {
      field: () =>
        import('./entity-exist-checker').then(
          m => m.EntityExistCheckerFormField,
        ),
    },
  });
